import { assign } from 'lodash';

export default class AppController {
    constructor($stateParams, ApiDashboard) {
        this.showStartupHelpWizard = $stateParams.showHelp;
        this.ApiDashboard = ApiDashboard;
    }

    init(){
        this.isStartupDisplayed = this.ApiDashboard.isStartupDisplayed;
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/app.controller.js
 **/